import { Box, Button } from "@mui/material";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
};

export const LoadMoreButton = ({
  isFetchingNextPage,
  hasNextPage,
  fetchNextPage,
}: Props) => {
  const { t } = useResource();

  if (isFetchingNextPage) {
    return (
      <Box mt={4}>
        <CenteredCircularProgress size={21} />
      </Box>
    );
  }

  if (hasNextPage) {
    return (
      <Box display="flex" justifyContent="center">
        <Button
          variant="text"
          color="info"
          size="small"
          onClick={fetchNextPage}
        >
          {t(Resources.Components.Transactions.LoadMore)}
        </Button>
      </Box>
    );
  }

  return null;
};
